import { Component, OnInit } from "@angular/core";
import { FormBuilder } from "@angular/forms";
import { BusinessService } from "../../../../common/services/Business.service";
import { UploadService } from "../../../../common/services/Upload.service";
import { Location } from "@angular/common";
import { EvsAddressService } from "../../../../common/services/EvsAddress.service";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";

declare var $: any;

@Component({
  selector: "app-business-password",
  templateUrl: "change-password.template.html",
  styleUrls: ["./business.css"],
  providers: [BusinessService, EvsAddressService, UploadService],
})
export class ChangePasswordComponent implements OnInit {
  password: any = {};
  data: any = {};
  constructor(
    private _fb: FormBuilder,
    private businessService: BusinessService,
    private addressService: EvsAddressService,
    private upload: UploadService,
    private toastr: ToastrService,
    private _location: Location,
    private translate: TranslateService
  ) { }

  ngOnInit() { }
  changePassword(data) {
    // console.log(data);
    // let body = {
    //   newPassword: data.new_password,
    //   oldPassword: data.password,
    // };

    this.businessService
      .resetPassword(data)
      .toPromise()
      .then((res: any) => {
        console.log(res);
        if (res.error) {
          this.toastr.warning(res.message, this.translate.instant('THONG_BAO'));
        } else {
          this.toastr.success(this.translate.instant('DOI_MAT_KHAU_THANH_CONG'), this.translate.instant('THONG_BAO'));
        }
      })
      .catch((err: any) => {
        this.toastr.warning(err.message, this.translate.instant('THONG_BAO'));
      });
  }
  backToComponent() {
    this._location.back();
  }
}



// WEBPACK FOOTER //
// /app/src/app/pages/admin/evs/business/change-password.component.ts